var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaudInterview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83302 0.333496C3.29325 0.333496 3.66635 0.706593 3.66635 1.16683V2.00017H4.49969C4.95993 2.00017 5.33302 2.37327 5.33302 2.8335C5.33302 3.29374 4.95993 3.66684 4.49969 3.66684H3.66635V4.50018C3.66635 4.96041 3.29325 5.33351 2.83302 5.33351C2.37278 5.33351 1.99968 4.96041 1.99968 4.50018V3.66684H1.16634C0.706105 3.66684 0.333008 3.29374 0.333008 2.8335C0.333008 2.37327 0.706105 2.00017 1.16634 2.00017H1.99968V1.16683C1.99968 0.706593 2.37278 0.333496 2.83302 0.333496ZM2.83302 8.66685C3.29325 8.66685 3.66635 9.03995 3.66635 9.50019V10.3335H4.49969C4.95993 10.3335 5.33302 10.7066 5.33302 11.1669C5.33302 11.6271 4.95993 12.0002 4.49969 12.0002H3.66635V12.8335C3.66635 13.2938 3.29325 13.6669 2.83302 13.6669C2.37278 13.6669 1.99968 13.2938 1.99968 12.8335V12.0002H1.16634C0.706105 12.0002 0.333008 11.6271 0.333008 11.1669C0.333008 10.7066 0.706105 10.3335 1.16634 10.3335H1.99968V9.50019C1.99968 9.03995 2.37278 8.66685 2.83302 8.66685Z",
    fill: "#252919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66632 0.333496C9.04444 0.333496 9.37516 0.588066 9.47192 0.953588L10.4546 4.66595L13.2494 6.27836C13.5074 6.42719 13.6663 6.70237 13.6663 7.00018C13.6663 7.298 13.5074 7.57318 13.2494 7.72201L10.4546 9.33442L9.47192 13.0468C9.37516 13.4123 9.04444 13.6669 8.66632 13.6669C8.28821 13.6669 7.95749 13.4123 7.86073 13.0468L6.87805 9.33441L4.08325 7.722C3.82528 7.57318 3.66635 7.298 3.66635 7.00018C3.66635 6.70237 3.82528 6.42719 4.08325 6.27836L6.87805 4.66595L7.86073 0.953588C7.95749 0.588066 8.28821 0.333496 8.66632 0.333496Z",
    fill: "#252919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaudInterview);
export default __webpack_public_path__ + "static/media/saud-interview.ec0ebe4b70ec83b10b51d9382cde6d83.svg";
export { ForwardRef as ReactComponent };